// extracted by mini-css-extract-plugin
export default {"section-title":"TitleSection_section-title__Rvzmx","title":"TitleSection_title__ftKo6"};